import axios from 'axios';
import config from '@/config/env-constants';

export default {

  getStickers(filterBy, view, currUserId) {
    const url = `${config.cloudFunctionsBaseUrl}/getStickers`;
    return axios.post(url, {
      view: view,
      currUserId: currUserId,
      filterBy: JSON.stringify(filterBy)
    });
  },

  validateStickers(payload, currUserId) {
    const url = `${config.cloudFunctionsBaseUrl}/validateStickers`;
    return axios.post(url, {
      currUserId: currUserId,
      type: payload.type,
      ...payload.stickerDetails
    });
  },

  generateStickers(payload, currUserId) {
    const url = `${config.cloudFunctionsBaseUrl}/generateStickers`;
    return axios.post(url, {
      currUserId: currUserId,
      ...payload
    });
  }
}